import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://snkthiiudjitcfuyliuw.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNua3RoaWl1ZGppdGNmdXlsaXV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgxNDgxMTgsImV4cCI6MjA4MzcyNDExOH0.cGt27YL73zwhI---13_B9_rDQDovqIG0Y4BoxOZfTGc';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
  console.error('URL:', supabaseUrl);
  console.error('Key:', supabaseAnonKey ? 'Present' : 'Missing');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

